import { render, staticRenderFns } from "./BiliUpList.vue?vue&type=template&id=1d99d5d0&scoped=true&"
import script from "./BiliUpList.vue?vue&type=script&lang=js&"
export * from "./BiliUpList.vue?vue&type=script&lang=js&"
import style0 from "./BiliUpList.vue?vue&type=style&index=0&id=1d99d5d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99d5d0",
  null
  
)

export default component.exports